import { defaultsDeep } from 'lodash';
import omitDeepByValues from 'omit-deep-by-values';

export const mergeInitialValues = <T>(initialValues: T, data: object) => {
  const omittedData = omitDeepByValues(data, [null, undefined, '', []]);

  return defaultsDeep(omittedData, initialValues) as T;
};
